<template>
  <div class="settings-fields col-12" v-if="elements.length">
    <table class="settings-fields__table table">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Show</th>
          <th scope="col">Name</th>
          <th class="input-field" scope="col">New Field Name</th>
          <th scope="col" v-if="dataType === 'column-fields'"></th>
        </tr>
      </thead>
      <draggable draggable=".draggable" v-model="list" tag="tbody">
        <tr v-for="item in list" :key="item.id" class="draggable">
          <td scope="row" :class="{ draggable: !item.show }">
            <i title="Click & drag to order" class="icon icon-drag_handle text-main bold-me"></i>
          </td>
          <td class="draggable show-col">
            <div class="custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="'item' + item.name"
                v-model="item.show"
                @change="sortList"
              />
              <label role="button" class="custom-control-label" :for="'item' + item.name"></label>
            </div>
          </td>
          <td class="draggable">{{ item.name }}</td>
          <td class="draggable input-field">
            <input v-model="item.newName" type="text" class="form-control" :disabled="!item.show" />
          </td>
          <td v-if="dataType === 'column-fields'" class="draggable">
            <button
              class="settings-fields__deleteBtn btn btn-primary"
              @click.prevent="confirmDelete(item)"
            >
              Delete
            </button>
          </td>
        </tr>
      </draggable>
    </table>
    <div class="settings-fields__buttons">
      <button
        :disabled="buttonsDisabled"
        class="settings-fields__saveBtn btn btn-primary d-inline-block"
        @click.prevent="saveFields"
      >
        Save
      </button>
      <input
        v-if="addingNewField && dataType === 'column-fields'"
        class="form-control"
        v-model="newFieldName"
        type="text"
        placeholder="new_field_name"
      />
      <button
        :disabled="buttonsDisabled"
        v-if="dataType === 'column-fields'"
        class="settings-fields__addBtn btn btn-primary d-inline-block"
        title="Add"
        @click.prevent="addField"
      >
        {{ addingNewField ? 'Save field' : '+' }}
      </button>
      <div v-if="result" class="settings-fields__resultsAlert alert alert-primary" role="alert">
        {{ result }}
      </div>
    </div>

    <!-- Delete Message Modal -->
    <delete-message-modal
      class="delete-message-modal"
      :title="modalTitle"
      :message="modalMessage"
      :okButtonText="okButtonText"
      :cancel="true"
      @confirmed="deleteField"
    />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import * as api from '@/lib/api'
import MessageModal from '@/components/MessageModal'
import Vue from 'vue'

export default {
  name: 'settingsFieldsTable',
  components: {
    draggable,
    DeleteMessageModal: MessageModal,
  },
  props: {
    dataType: String,
    dataElements: Object,
  },
  data() {
    return {
      list: [],
      result: '',
      newFieldName: '',
      addingNewField: false,
      // delete modal
      selectedFieldForDelete: null,
      modalTitle: '',
      okButtonText: '',
      modalMessage: '',
      buttonsDisabled: false,
    }
  },
  computed: {
    searchParams() {
      return {
        size: 1000,
        from: 0,
        sort_by:
          this.dataType === 'aggregation-fields' ? 'aggregation_position' : 'column_position',
        order_by: 'asc',
      }
    },
    elements() {
      // return this.dataElements ? this.dataElements.results : []
      if (this.dataElements) {
        console.log(this.dataElements)
        let elements = []
        //convertimos aggregation_position y column_position a sencillamente position
        //convertimos aggregation_field_id y column_field_id a sencillamente id
        if (this.dataType == 'aggregation-fields') {
          elements = this.dataElements.results.map(
            ({ aggregation_field_id, aggregation_position, ...rest }) => ({
              id: aggregation_field_id,
              position: aggregation_position,
              ...rest,
            })
          )
        } else if (this.dataType == 'column-fields') {
          elements = this.dataElements.results.map(
            ({ column_field_id, column_position, ...rest }) => ({
              id: column_field_id,
              position: column_position,
              ...rest,
            })
          )
        }
        return elements.map((el) =>
          Object.assign({
            id: el.id,
            show: el.position != -1,
            name: el.field_name,
            oldName: el.field_renamed,
            newName: el.field_renamed,
            oldPosition: el.position,
          })
        )
      } else {
        return []
      }
    },
  },
  mounted() {
    this.$emit('getElements', this.dataType, this.searchParams)
  },
  methods: {
    // save fields to backend (only those modified by admin user)
    async saveFields() {
      // disable buttons until response is received
      this.buttonsDisabled = true
      const orderArr = this.list.map((el, idx) => {
        el.newPosition = el.show ? idx + 1 : -1
        return el
      })
      // this.result = JSON.stringify(orderArr)
      let saveArr = orderArr.filter(
        (el) => el.newPosition != el.oldPosition || el.oldName != el.newName
      )
      // for multiple await can't use forEach unfortunately but ...
      let editedFields = []
      for (const el of saveArr) {
        const response = await api.saveField(this.dataType, el.id, this.apiParams(el))
        editedFields.push(response)
      }
      this.result = editedFields.length
        ? `${editedFields.length} field/s modified`
        : 'Nothing to save'
      // renable buttons when result is received
      this.buttonsDisabled = false
      setTimeout(() => (this.result = ''), 1000)
      this.$emit('getElements', this.dataType, this.searchParams)
    },
    // gets the right apiParams for the api from an object 'el'
    apiParams(el) {
      let apiParams
      if (this.dataType == 'aggregation-fields') {
        apiParams = {
          field_name: el.name,
          field_renamed: el.newName,
          aggregation_position: el.newPosition,
        }
      } else {
        apiParams = {
          field_name: el.name,
          field_renamed: el.newName,
          column_position: el.newPosition,
        }
      }
      return apiParams
    },
    //sort only "show == false" values to the end of the list
    sortList() {
      this.list.sort((a, b) => {
        if (a.show > b.show) {
          return -1
        }
        return 1
      })
    },
    // add new field
    async addField() {
      if (this.addingNewField) {
        const response = await api.addField(this.dataType, {
          field_name: this.newFieldName,
          field_renamed: this.newFieldName,
          column_position: this.list.length,
        })
        console.log('ADDING NEW FIELD', response)
        // clear newfield name
        this.newFieldName = ''
        // update list
        this.$emit('getElements', this.dataType, this.searchParams)
      }
      this.addingNewField = !this.addingNewField
    },
    // confirm delete field
    confirmDelete(data) {
      console.log('trying to delete item', data.id)
      this.selectedFieldForDelete = data
      this.modalTitle = 'Confirm Delete'
      this.modalMessage = `Are you sure you want to delete ${this.dataType} ${data.id} ${
        data.name
      }?`
      this.okButtonText = 'Delete'
      Vue.nextTick(() => {
        $('.delete-message-modal').modal('show')
      })
    },
    // delete field
    async deleteField() {
      await api.deleteField(this.dataType, this.selectedFieldForDelete.id)
      this.selectedFieldForDelete = null
      // SHOULD RELOAD AFTER DELETE
      this.$emit('getElements', this.dataType, this.searchParams)
    },
  },
  watch: {
    dataType() {
      this.$emit('getElements', this.dataType, this.searchParams)
    },
    elements() {
      this.list = this.elements
      this.sortList()
    },
  },
}
</script>
<style lang="scss" scoped>
#app table.settings-fields {
  &__table {
    margin-top: 0;
    .icon-drag_handle {
      cursor: grab;
      &:active {
        cursor: grabbing;
      }
    }

    td {
      min-width: 50px;
      white-space: nowrap;
      vertical-align: middle;

      &.show-col {
        text-align: center;

        .custom-checkbox {
          padding-left: 15px;

          input {
            position: relative;
          }
        }
      }

      &.input-field {
        width: 99%;
      }
    }
  }
}

.settings-fields {
  &__buttons {
    display: flex;
    max-width: 600px;
  }

  &__saveBtn,
  &__addBtn {
    margin-right: 1rem;
    margin-bottom: 1rem;
    vertical-align: baseline;
    white-space: nowrap;
  }

  &__resultsAlert {
    display: inline-block;
    margin-left: 20px;
    margin-bottom: 16px;
    padding: 8px;
    white-space: nowrap;
  }
}
</style>
